const serviceStatusEnum = Object.freeze({
  LIVE: 'live',
  COMING_SOON: 'coming_soon'
})

export { serviceStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/ServiceStatusEnum.js